
import { Routes,Route } from 'react-router-dom';
import {Container} from './EventsDetail.style';
import RegisterBtn from './RegisterBtn';
import './EventDetails.css'
import image1 from '../../assets/img/Design-thinking/design-thinking-1.png'
import image3 from '../../assets/img/Design-thinking/design-thinking-3.png'
import image2 from '../../assets/img/Design-thinking/design-thinking-2.png'
import { Fade, Zoom } from 'react-reveal';
import banner_img from '../../assets/img/Design-thinking/create-evolve-repeat.png'

function EventsDetails(props) {
  return (

<>
<section className='event-wrapper container'>
  <Zoom>

<div className="banner-text">
          <h1 className='text-black text-center'>Analyze and <span>CREATE</span> a solution for the challenges of<span> INNOVATION</span></h1>
  </div>
  </Zoom>

</section>
    <Container className='container'>


      <div className="container">
        <div className="row mid-colum-container justify-content-around aligh-item-center">
          <Fade left>

          <div className="col-xl-7 col-sm-12 event-title-small">
              <div className="row">
            <div className="col-xl-3 col-sm-5">
            <img src={image2} alt="" />
            </div>
            <div className='col-xl-8 col-sm-5 event-mini-details'>
              <li className='h5'>{props.title} </li>
              <li>Event Period</li>
              <li>Location</li>
            </div>
              </div>

          </div>
          </Fade>


          <div className="col-xl-4 col-sm-4 register-box">
            <Fade>
            <RegisterBtn/>  
              </Fade>
          </div>
          </div>


<Fade up>

          <section id='event-detail-design-thinking'>
            <p>Our design thinking sessions create an entrepreneurial process that can help entrepreneurs and startup founders systematically extract, educate, learn, and apply those human-centered techniques to solve problems in a creative and innovative way- in our personal and professional life. </p>

      {/* <strong className='font-weight-bold'>

                <p>Create - Opportunity</p>
                <p>Evolve-  Confidence</p>
                <p>Repeat-  Leadership</p>
      </strong> */}
      <div className='create-evolve-repeat'>
        <img src={banner_img} alt="" />
      </div>

                <p>
        The design thinking networking event is an excellent opportunity for rearing entrepreneurs to gain insights on how existing businesses run and keep on track in today’s competitive market. From the CEO of Lacuna Venture to the founder of Khudra Asia, our guest speakers present on the key of their own successes. We also facilitate interested newcomers to pitch their ideas and brands to the audience towards the end of the programme.

        </p>
          </section>
          </Fade>

      </div>
      <Fade> 


      <section>
        <h2 className='text-start'>Lacuna Venture Design Thinking Pattern</h2>

        <p>Identify- User’s needs, users problem, your solution</p>
        <p>Ideate- Creating Innovative Solutions</p>
        <p>Prototype- Start Creating Solutions</p>
        <p>Test- Solutions</p>

        <p>

        Now go forth you brave pioneers who have had enough. Create something that can revolutionize life for humanity forevermore!
          
        </p>
      </section>
      </Fade>

    <h2 className='h1 container'>Gallery</h2>
      <div className="container gallery-container">
        {/* Gallery */}


  <div id="carouselExampleControls" class="carousel slide gallery-slider" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div className="row">
        <div className="col-4">

      <img src={image1} class="d-block w-100" alt="..."/>
        </div>
        <div className="col-4">

      <img src={image2} class="d-block w-100" alt="..."/>
        </div>
        <div className="col-4">

      <img src={image3} class="d-block w-100" alt="..."/>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div className="row">
        <div className="col-4">

      <img src={image1} class="d-block w-100" alt="..."/>
        </div>
        <div className="col-4">

      <img src={image2} class="d-block w-100" alt="..."/>
        </div>
        <div className="col-4">

      <img src={image3} class="d-block w-100" alt="..."/>
        </div>
      </div>
    </div>

  </div>

  <button class="carousel-control-prev hide-on-phone" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next hide-on-phone" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
        
        
      </div>
        
    </Container>
    </>

  )
}

export default EventsDetails
